package org.bsvac.bsvac_kmp.data.fakeData

import org.bsvac.bsvac_kmp.data.models.AgencyModel
import org.bsvac.bsvac_kmp.data.models.AmbulanceUnitModel
import org.bsvac.bsvac_kmp.data.models.BoroughModel
import org.bsvac.bsvac_kmp.data.models.CertificationModel
import org.bsvac.bsvac_kmp.data.models.CrewModel
import org.bsvac.bsvac_kmp.data.models.LogonOptionModel
import org.bsvac.bsvac_kmp.data.models.RadioModel
import org.bsvac.bsvac_kmp.data.models.TourModel
import kotlin.collections.List

object DataSource {

    fun TourOptions(): List<String> {
        return listOf( "Tour 1", "Tour 2", "Tour 3")
    }

    fun BoroughOptions(): List<String> {
        return listOf("Brooklyn North",
            "Brooklyn South",
            "Bronx East",
            "Bronx West"
        )
    }

    fun LogonHeader(): String  = "CADLOGON"

    fun RadioOptions(): List<String> {
        return listOf("NYPD 1", "NYPD 2", "NYPD 3", "NYPD 4")
    }

    fun CrewMemberOptions(): List<String> {
        return listOf("Amy", "Mary", "BoPete", "Rudolph")
    }

    fun UnitOptions(): List<String> {
        return listOf("BSVAC1", "BSVAC2", "BSVAC3")
    }

    fun AgencyOptions(): List<String> {
        return listOf("Bedford Stuyvensant Volunteer Ambulance Corp", "Gotham Volunteer Ambulance Corp")
    }

    fun SelectRadioHint(radioNumber: Int): String {
        return "Select Radio $radioNumber"
    }

    fun SelectRadioLabel(radioNumber: Int): String {
        return "Radio $radioNumber:"
    }

    fun StatusBarMessage(): String {
        return "No more Messages"
    }

    fun StatusBarSymbol(): String {
        return "G"
    }

    fun StatusDateString(): String {
        return "Time"
    }
    fun BoroughCoverageHint(): String {
        return "Select Coverage Borough"
    }

    fun BoroughCoverageLabel(): String {
        return "Borough Coverage:"
    }

    fun SelectTourHint(): String {
        return "Select Tour"
    }

    fun SelectTourLabel(): String {
        return "Tour:"
    }

    fun SelectCrewMemberHint(crewNumber: Int): String {
        return "Select Crew $crewNumber"
    }

    fun SelectCrewLabel(crewNumber: Int): String {
        return "Crew $crewNumber:"
    }

    fun SelectUnitHint(): String {
        return "Select Unit"
    }

    fun SelectUnitLabel(): String {
        return "Unit:"
    }

    fun ErrorDialogTimeoutMs(): Long {
        return 5000L
    }

    fun ErrorDialogPreviewParameters(): List<String?> {
        return listOf<String?>(
            null,
            "Unable to load content",
            "Failure"
        )
    }

    fun ErrorDialogContentDescription(): String {
        return "Sample icon"
    }

    fun SelectAgencyHint(): String {
        return "Select Agency"
    }

    fun SelectAgencyLabel(): String {
        return "Agency:"
    }

    fun LogonStatusMessage(): String {
        return "NO STATUS"
    }

    /*
    fun LogonOptionModels(): List<LogonOptionModel> {
        val bsvacUnitOptions = listOf(
            AmbulanceUnitModel.BSVAC_2,
            AmbulanceUnitModel.BSVAC_3,
            AmbulanceUnitModel.BSVAC_4,
            AmbulanceUnitModel.BSVAC_5,
            AmbulanceUnitModel.BSVAC_6
        )
        val bsvacBoroughOptions = listOf(
            BoroughModel.BK_NORTH,
            BoroughModel.BK_CENTRAL
        )
        val tourOptions = listOf(
            TourModel.TOUR_1,
            TourModel.TOUR_2,
            TourModel.TOUR_3,
            TourModel.STANDBY
        )
        val bsvacCrewOptions = listOf(
            CrewModel.POINTER_JAMES,
            CrewModel.DELOSANTOS_LEONEL,
            CrewModel.ROBINSON_ANTOINE,
            CrewModel.BYAM_MATTHEW,
            CrewModel.THOMAS_WARREN,
            CrewModel.FRAGOSA_ANDREW,
            CrewModel.CARRANZA_MARIA
        )
        val bsvacRadioOptions = listOf(
            RadioModel.NYPD_1,
            RadioModel.NYPD_2,
            RadioModel.NYPD_3,
            RadioModel.NYPD_4,
            RadioModel.NYPD_5,
            RadioModel.PORT_1,
            RadioModel.PORT_2,
            RadioModel.PORT_3,
            RadioModel.PORT_4,
            RadioModel.PORT_5,
            RadioModel.PORT_6
        )
        val gothamUnitOptions = listOf (
            AmbulanceUnitModel.GVEMS_7,
            AmbulanceUnitModel.GVEMS_8,
            AmbulanceUnitModel.GVEMS_9
        )
        val gothamBoroughOptions = listOf (
            BoroughModel.BK_NORTH,
            BoroughModel.QUEENS_WEST
        )

        val gothamCrewOptions = listOf(
            CrewModel.RODRIGUEZ_JESUS,
            CrewModel.SEXTON_KATHY,
            CrewModel.PRICE_JAMES,
            CrewModel.GRAVES_SEAN
        )
        val gothamRadioOptions = listOf(
            RadioModel.RADIO_1,
            RadioModel.RADIO_2,
            RadioModel.RADIO_3,
            RadioModel.RADIO_4,
            RadioModel.RADIO_5
        )
        return listOf(
            LogonOptionModel(
                AgencyModel.BSVAC,
                bsvacUnitOptions,
                bsvacBoroughOptions,
                tourOptions,
                bsvacCrewOptions,
                bsvacRadioOptions
            ),
            LogonOptionModel(
                AgencyModel.GVEMS,
                gothamUnitOptions,
                gothamBoroughOptions,
                tourOptions,
                gothamCrewOptions,
                gothamRadioOptions
            )
        )
    }

     */
}